import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataSourceRequestState, DataResult } from '@progress/kendo-data-query';
import { AppConstant } from 'src/app/app.constant';

@Injectable()
export class HolidayService {
    apiUrl: string;
    kendoDataUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }
    manageHoliday(holiday) {
        return this.httpClient.post(`${this.apiUrl}/manageHoliday`, holiday).pipe(map((response: any) => {
            return response;
        }))
    }
    bulkInsert(holiday) {
        return this.httpClient.post(`${this.apiUrl}/holidayBulkImport`, holiday).pipe(map((response: any) => {
            return response;
        }))
    }
    updateHoliday(holiday) {
        return this.httpClient.post(`${this.apiUrl}/manageHoliday`, holiday).pipe(map((response: any) => {
            return response;
        }))
    }
    deleteHoliday(holiday) {
        return this.httpClient.post(`${this.apiUrl}/manageHoliday/`,holiday).pipe(map(data => data));
    }
    public getAllHolidays(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllHoliday/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total:  response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    public getAllHolidaysExcel(branchId: number, year: string) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/holidayListExcel/` + branchId + '/app/' + year).pipe(map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    getHolidayById(InstituteId) {
        return this.httpClient.get(`${this.apiUrl}/getHolidayById/` + InstituteId).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
}